// extracted by mini-css-extract-plugin
module.exports = {"preliminaryTitle":"_u9","tooltip":"_va","propertyContainer":"_vb","infoIcon":"_vc","big":"_vd","gray":"_ve","title":"_vf"};